import { COMMON_MESSAGES, SEARCH_MIN_QUERY_LENGTH } from '../search-modal.const'
import type { EmptyStateParams } from '../search-modal.interface'
import { isSearchQueryTooShort } from '../search-modal.utils'

export function buildSearchEmptyState(params: EmptyStateParams): string | undefined {
  const { debouncedQueryTrimmed, fetchError, isLoading, sections } = params
  const noItems = sections.every((s) => s.items.length === 0)

  if (fetchError) {
    return fetchError
  }

  if (isLoading || !noItems) {
    return undefined
  }

  if (isSearchQueryTooShort(debouncedQueryTrimmed)) {
    return COMMON_MESSAGES.queryTooShort(SEARCH_MIN_QUERY_LENGTH)
  }

  if (debouncedQueryTrimmed.length >= SEARCH_MIN_QUERY_LENGTH) {
    return COMMON_MESSAGES.noMatches
  }

  return COMMON_MESSAGES.typeToSearch
}
